import React, { useState } from "react";

import { FaTimes } from "react-icons/fa";

import { toast } from "react-toastify";

import "./ProviderTrackingNew.css";

import {
  createProviderTrackingSummary,
} from "../../config/LiveApi";

const AddProviderTracking = ({
  onClose,
  onSuccess,
}) => {
  const [loading, setLoading] =
    useState(false);

  const [formData, setFormData] =
    useState({
      orgName: "",
      pg: "",
      type: "",
      remark: "",
      providerId: "",

      txnDateRanges: [
        {
          startDate: "",
          endDate: "",
          remark: "",
        },
      ],
    });

  const handleChange = (e) => {
    setFormData({
      ...formData,

      [e.target.name]:
        e.target.value,
    });
  };

  const handleSessionChange = (
    index,
    field,
    value,
  ) => {
    const updatedRanges = [
      ...formData.txnDateRanges,
    ];

    updatedRanges[index][field] =
      value;

    setFormData({
      ...formData,

      txnDateRanges:
        updatedRanges,
    });
  };

  const addSession = () => {
    setFormData({
      ...formData,

      txnDateRanges: [
        ...formData.txnDateRanges,

        {
          startDate: "",
          endDate: "",
          remark: "",
        },
      ],
    });
  };

  const removeSession = (index) => {
    const updatedRanges =
      formData.txnDateRanges.filter(
        (_, idx) =>
          idx !== index,
      );

    setFormData({
      ...formData,

      txnDateRanges:
        updatedRanges,
    });
  };

  const convertToISODate = (
    date,
  ) => {
    if (!date) return null;

    return new Date(
      `${date}T00:00:00.000Z`,
    ).toISOString();
  };

  const handleSubmit = async (
    e,
  ) => {
    e.preventDefault();

    try {
      setLoading(true);

      const payload = {
        orgName:
          formData.orgName,

        pg: formData.pg,

        type: formData.type,

        remark:
          formData.remark,

        providerId:
          formData.providerId,

        txnDateRanges:
          formData.txnDateRanges.map(
            (item) => ({
              startDate:
                convertToISODate(
                  item.startDate,
                ),

              endDate:
                item.endDate
                  ? convertToISODate(
                      item.endDate,
                    )
                  : null,

              remark:
                item.remark,
            }),
          ),
      };

      console.log(
        "PAYLOAD => ",
        payload,
      );

      const response =
        await createProviderTrackingSummary(
          payload,
        );

      if (response?.status) {
        toast.success(
          "Provider Tracking Created",
        );

        onSuccess();

        onClose();
      } else {
        toast.error(
          response?.message ||
            "Something went wrong",
        );
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);

      toast.error(
        error?.response?.data
          ?.message ||
          "Failed to create tracking",
      );
    }
  };

  return (
    <div className="provider-modal-overlay">
      <div className="provider-modal-content">
        <button
          onClick={onClose}
          className="provider-modal-close-btn"
        >
          <FaTimes size={20} />
        </button>

        <h2 className="provider-modal-title">
          Add Provider Tracking
        </h2>

        <form
          onSubmit={handleSubmit}
          className="provider-form"
        >
          <div className="provider-grid">
            <div className="provider-input-group">
              <label>
                Org Name
              </label>

              <input
                type="text"
                name="orgName"
                value={
                  formData.orgName
                }
                onChange={
                  handleChange
                }
                required
              />
            </div>

            <div className="provider-input-group">
              <label>
                Provider
              </label>

              <input
                type="text"
                name="pg"
                value={
                  formData.pg
                }
                onChange={
                  handleChange
                }
                required
              />
            </div>

            <div className="provider-input-group">
              <label>
                Type
              </label>

              <input
                type="text"
                name="type"
                placeholder="PAYIN / PAYOUT"
                value={
                  formData.type
                }
                onChange={
                  handleChange
                }
              />
            </div>

            <div className="provider-input-group">
              <label>
                Provider ID
              </label>

              <input
                type="text"
                name="providerId"
                value={
                  formData.providerId
                }
                onChange={
                  handleChange
                }
              />
            </div>

            <div className="provider-input-group provider-full-width">
              <label>
                Global Remark
              </label>

              <textarea
                name="remark"
                rows="3"
                value={
                  formData.remark
                }
                onChange={
                  handleChange
                }
              />
            </div>
          </div>

          <div className="provider-session-wrapper">
            <div className="provider-session-header">
              <h3>
                Session Details
              </h3>

              <button
                type="button"
                className="provider-add-session-btn"
                onClick={
                  addSession
                }
              >
                + Add Session
              </button>
            </div>

            {formData.txnDateRanges.map(
              (
                session,
                index,
              ) => (
                <div
                  className="provider-session-card"
                  key={index}
                >
                  <div className="provider-session-top">
                    <h4>
                      Session{" "}
                      {index + 1}
                    </h4>

                    {formData
                      .txnDateRanges
                      .length >
                      1 && (
                      <button
                        type="button"
                        className="provider-remove-btn"
                        onClick={() =>
                          removeSession(
                            index,
                          )
                        }
                      >
                        Remove
                      </button>
                    )}
                  </div>

                  <div className="provider-grid">
                    <div className="provider-input-group">
                      <label>
                        Start Date
                      </label>

                      <input
                        type="date"
                        value={
                          session.startDate
                        }
                        onChange={(
                          e,
                        ) =>
                          handleSessionChange(
                            index,
                            "startDate",
                            e.target
                              .value,
                          )
                        }
                        required
                      />
                    </div>

                    <div className="provider-input-group">
                      <label>
                        End Date
                      </label>

                      <input
                        type="date"
                        value={
                          session.endDate
                        }
                        onChange={(
                          e,
                        ) =>
                          handleSessionChange(
                            index,
                            "endDate",
                            e.target
                              .value,
                          )
                        }
                      />
                    </div>

                    <div className="provider-input-group provider-full-width">
                      <label>
                        Session Remark
                      </label>

                      <textarea
                        rows="2"
                        value={
                          session.remark
                        }
                        onChange={(
                          e,
                        ) =>
                          handleSessionChange(
                            index,
                            "remark",
                            e.target
                              .value,
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              ),
            )}
          </div>

          <button
            className="provider-submit-btn"
            type="submit"
            disabled={loading}
          >
            {loading
              ? "Creating..."
              : "Create Tracking"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddProviderTracking;